<div style="min-height: 70vh">
  <h2>
    <span>GAE Staff Report</span>
    <mat-icon wfdssAppHelp [attr.data-madcap-id]="1046" style="position: relative; top: 0.25rem; color: blue; padding-left: .3rem;"
    >help_outline</mat-icon>    
  </h2>
  
  <wfdss-configurable-mat-table
    [displayPointerOnHover]="false"
    [dataSource]="gaeStaffData"
    [columnMetaInformationIn]="gaeStaffTableColumnMetaData"
    [showExport]="'Download GAE Staff Report CSV file'"
    exportPrefix="WFDSS GAE Staff Report-"
    exportSuffix=""
    [sortingDataAccessor]="sortingDataAccessor"
  ></wfdss-configurable-mat-table>
</div>
